import React, { Component } from 'react';
import { RootState } from '../../../redux/store';
import { connect } from 'react-redux';
import { ConnectedProps } from 'react-redux/es/exports';
import AccessContainer from '../../access/AccessContainer';
import { AccessBase } from '../../../domain/access/BaseAccess';
import RoleHelper from '../../../RoleHelper';
import { changeStruct } from '../../../redux/actions/StructActions';

class StructAccessComponent extends Component<Props> {
  render() {
    const {
      struct: { struct },
    } = this.props;
    const access: AccessBase = { permission: struct.permission, collaborators: struct.collaborators };
    return <AccessContainer access={access} changeAccess={this.changeAccess} disabled={!RoleHelper.canManage('Struct')} />;
  }

  private changeAccess = (access: AccessBase) => {
    const {
      struct: { struct },
      changeStruct,
    } = this.props;
    struct.permission = access.permission;
    struct.collaborators = access.collaborators;
    changeStruct(struct);
  };
}

interface Props extends ReduxProps {}

const mapStateToProps = (state: RootState) => ({
  struct: state.struct,
});

const mapDispatchToProps = { changeStruct };
const connector = connect(mapStateToProps, mapDispatchToProps);
type ReduxProps = ConnectedProps<typeof connector>;
export default connector(StructAccessComponent);
